import { TDocumentStatus } from '../../apis/documents/documents.interfaces';
import { TDocumentType } from '../../apis/documents/documents.interfaces';
import { GENDER, TUserDetails } from '../../apis/users/users.interfaces';
import { mockDocument } from '../documents/documentMock';
import { mockUserAction } from './userAction';

export const mockUserDetails: TUserDetails = {
  id: '123456789',
  basicDetails: {
    id: '123456789',
    firstName: 'Arjun',
    middleName: null,
    lastName: 'Kumar',
    gender: GENDER.MALE,
    profile: {
      profilePicture: mockDocument,
      idProof: mockDocument,
      addressProof: mockDocument,
    },
    emergencyContact: {
      id: 'emergency-123',
      firstName: 'Sunita',
      middleName: null,
      lastName: 'Agarwal',
      gender: GENDER.FEMALE,
      relationship: 'Mother',
      phone: {
        countryCode: '+91',
        phoneNumber: '9876543210',
        isVerified: true,
      },
        email: {
          email: 'meera.iyer@example.com',
          isVerified: true,
        },
      address: {
        address1: '123 Mumbai Street',
        address2: 'Apartment 4B',
        city: 'Mumbai',
        state: 'Maharashtra',
        country: 'India',
        postalCode: '400001',
        isCurrent: true,
        description: 'Current residence',
      },
    },
  },
  actions: {
    created: mockUserAction,
    updated: mockUserAction,
  },
  contactDetails: {
    phone: {
      countryCode: '+91',
      phoneNumber: '9876543210',
      isVerified: true,
    },
    email: {
      email: 'arjun.kumar@example.com',
      isVerified: true,
    },
    address: {
      address1: '123 Mumbai Street',
      address2: 'Apartment 4B',
      city: 'Mumbai',
      state: 'Maharashtra',
      country: 'India',
      postalCode: '400001',
      isCurrent: true,
      description: 'Current residence',
    },
  },
  documents: [
    {
      fileUrl: 'https://example.com/aadhar-card-arjun.pdf',
      documentName: 'Aadhar Card - Arjun Kumar.pdf',
      description: 'Aadhar Card for Arjun Kumar',
      uploadedAt: mockUserAction,
      documentId: '123456789',
      userId: '123456789',
      documentType: TDocumentType.AADHAR_CARD,
      submissionDate: '2021-01-01',
      status: TDocumentStatus.VERIFIED,
      verificationDate: '2021-01-05',
      remarks: 'Document verified successfully',
    },
    {
      fileUrl: 'https://example.com/pan-card-arjun.pdf',
      documentName: 'PAN Card - Arjun Kumar.pdf',
      description: 'PAN Card for Arjun Kumar',
      uploadedAt: mockUserAction,
      documentId: '123456790',
      userId: '123456789',
      documentType: TDocumentType.PAN_CARD,
      submissionDate: '2021-01-02',
      status: TDocumentStatus.VERIFIED,
      verificationDate: '2021-01-06',
      remarks: 'PAN card verified',
    },
  ],
};

export const mockStudentUserDetails: TUserDetails = {
  id: '987654321',
  basicDetails: {
    id: '987654321',
    firstName: 'Priya',
    middleName: 'Kumari',
    lastName: 'Sharma',
    gender: GENDER.FEMALE,
    profile: {
      profilePicture: mockDocument,
      idProof: mockDocument,
      addressProof: mockDocument,
    },
    emergencyContact: {
      id: 'emergency-456',
      firstName: 'Rajesh',
      middleName: null,
      lastName: 'Sharma',
      gender: GENDER.MALE,
      relationship: 'Father',
      phone: {
        countryCode: '+91',
        phoneNumber: '9123456789',
        isVerified: true,
      },
      email: {
        email: 'rajesh.sharma@example.com',
        isVerified: true,
      },
      address: {
        address1: '456 Delhi Avenue',
        address2: 'Flat 5C',
        city: 'Delhi',
        state: 'Delhi',
        country: 'India',
        postalCode: '110001',
        isCurrent: true,
        description: 'Current residence',
      },
    },
  },
  actions: {
    created: mockUserAction,
    updated: mockUserAction,
  },
  contactDetails: {
    phone: {
      countryCode: '+91',
      phoneNumber: '9123456789',
      isVerified: true,
    },
    email: {
      email: 'priya.sharma@example.com',
      isVerified: true,
    },
    address: {
      address1: '456 Delhi Avenue',
      address2: 'Flat 5C',
      city: 'Delhi',
      state: 'Delhi',
      country: 'India',
      postalCode: '110001',
      isCurrent: true,
      description: 'Current residence',
    },
  },
  documents: [
    {
      fileUrl: 'https://example.com/birth-certificate-priya.pdf',
      documentName: 'Birth Certificate - Priya Sharma.pdf',
      description: 'Birth Certificate for Priya Sharma',
      uploadedAt: mockUserAction,
      documentId: '987654321',
      userId: '987654321',
      documentType: TDocumentType.BIRTH_CERTIFICATE,
      submissionDate: '2021-01-01',
      status: TDocumentStatus.VERIFIED,
      verificationDate: '2021-01-05',
      remarks: 'Birth certificate verified',
    },
    {
      fileUrl: 'https://example.com/aadhar-card-priya.pdf',
      documentName: 'Aadhar Card - Priya Sharma.pdf',
      description: 'Aadhar Card for Priya Sharma',
      uploadedAt: mockUserAction,
      documentId: '987654322',
      userId: '987654321',
      documentType: TDocumentType.AADHAR_CARD,
      submissionDate: '2021-01-02',
      status: TDocumentStatus.VERIFIED,
      verificationDate: '2021-01-06',
      remarks: 'Aadhar card verified',
    },
  ],
};
